<template>
  <div>
    <v-card>
      <v-card-title class="text-subtitle-1" v-if="groupData.title !== ''">
        {{ groupData.title }}
      </v-card-title>
      <v-card-subtitle class="text-subtitle-2" v-if="groupData.subtitle !== ''">
        {{ groupData.subtitle }}
      </v-card-subtitle>
      <v-radio-group
        v-show="groupData.group_item_type == 'radioBtn'"
        v-model="groupValue"
        color="primary"
        mandatory
        class="mt-0"
      >
        <v-list-item
          v-for="(item, i) in groupData.layers"
          :key="i"
          color="primary"
        >
          <v-list-item-content>
            <v-list-item-title>
              <v-radio :label="item.nice_name" :value="i"> </v-radio>
            </v-list-item-title>

            <StreamfieldBlock
              v-for="(block, blockIndex) in item.additional_detail"
              v-show="groupValue == i"
              :id="i"
              :key="blockIndex"
              :block="block"
            ></StreamfieldBlock>
            <!-- <v-list-item-subtitle v-text="item.nice_name" class="ml-8"></v-list-item-subtitle> -->
          </v-list-item-content>
        </v-list-item>
      </v-radio-group>

      <v-list v-show="groupData.group_item_type == 'checkBox'">
        <v-list-item-group
          multiple
          v-model="checkboxGroupValue"
          class="mt-0"
          color="primary"
        >
          <v-list-item
            v-for="(item, i) in groupData.layers"
            :value="item.layer_name"
            :key="i"
          >
            <template v-slot:default="{ active }">
              <v-list-item-action>
                <v-checkbox
                  :input-value="active"
          
                  color="secondary"
                ></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title v-text="item.nice_name"></v-list-item-title>
                <StreamfieldBlock
                  v-for="(block, blockIndex) in item.additional_detail"
                  v-show="checkboxGroupValue.includes(item.layer_name)"
                  :id="i"
                  :key="blockIndex"
                  :block="block"
                ></StreamfieldBlock>
              </v-list-item-content>
            </template>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import StreamfieldBlock from "../blocks/streamfieldBlock.vue";

export default {
  name: "ImageBlock",
  props: ["groupData"],
  components: {
    StreamfieldBlock,
  },
  data: () => ({
    groupValue: 0,
    checkboxGroupValue: [],
    checked: false,
    selectedItem: 0,
    showStream: false,
  }),
  mounted() {
    console.log(this.groupData, "grouped data");
  },
  beforeCreate: function () {
    this.$options.components.StreamfieldBlock =
      require("../blocks/streamfieldBlock.vue").default;
  },
  methods: {
    updateStore: function (visibleLayerIndex) {
      let layerOptionsData = {};

      //Iterate through the options on this group and set layer visibility
      this.groupData.layers.forEach(function (item, i) {
        let visible = i === visibleLayerIndex;
        let layers = item.layer_name.split(",");

        layers.forEach(function (layer) {
          if (visible) layerOptionsData[layer] = true;
          //Make layers that belong to the active radio button visible
          else if (!(layer in layerOptionsData))
            layerOptionsData[layer] = false; //Only set the layer to be invisible if its not already being set visible
        });
      });

      let payload = { key: this._uid, data: layerOptionsData };
      console.log("payloadRadio", payload);

      this.$store.commit("wagtail/setLayerOptions", payload);
    },

    updateStoreCheckbox: function (visibleLayerIndex) {
      let layerOptionsData = {};
      
      //Iterate through the options on this group and set layer visibility
      this.groupData.layers.forEach(function (item) {
        
        // Split the layers as we can reference multiple layers via a checkbox
        let layers = item.layer_name.split(",");

        // Get the visibility of this set of layers
        let visible = visibleLayerIndex.includes(item.layer_name)
        
        layers.forEach(function (layer) {
          layerOptionsData[layer] = visible //Add the layer along with its appropriate visibility
        });
      });

      let payload = { key: this._uid, data: layerOptionsData };

      console.log("payloadCheckbox", payload);
      this.$store.commit("wagtail/setLayerOptions", payload);
    },
  },
  created() {
    let self = this;

    this.groupData.layers.forEach(function (item, i) {
      if (item.active === true) self.groupValue = i;
    });

    this.groupData.layers.forEach(function (item) {
      if (item.active === true) self.checkboxGroupValue.push(item.layer_name);
    });

    this.showStream = true;
    //Ensure the first filter is applied at load
    this.updateStore(this.groupValue); 
    this.updateStoreCheckbox(this.checkboxGroupValue);

  },
  computed: {
    // tickLabels: function() {
    //   let labels = []
    //   this.sliderData.forEach( function(item) {
    //     labels.push(item.step)
    //   })
    //   return labels
    // }
    //Edit Here
    // isStreamfieldAvailable(){
    //  this.groupData.layers.forEach(function (item, i) {
    //   if (item.additional_detail == undefined || null) return true;
    //   return false
    // });
    // }
  },
  watch: {
    groupValue: function (newValue) {
      this.updateStore(newValue);
    },
    data: function (newVal) {
      console.log(newVal, "datastore");
    },
    checkboxGroupValue: function (newValue) {      
      this.updateStoreCheckbox(newValue);
    },
  },
  beforeDestroy() {
    let payload = { key: this._uid, data: null };
    this.$store.commit("wagtail/setLayerOptions", payload);
  },
};
</script>

<style scoped>
.radio-bg {
  background-color: rgb(229, 229, 229);
}
</style>